//@flow
import {
  endpoints,
  createStoreInformationBlockApi,
  deleteStoreInformationBlockApi,
  getStoreInformationBlockApi,
  listStoreInformationBlocksApi,
  updateStoreInformationBlockApi,
} from '../api/information-block';

import type {StoreInformationBlock} from '../../../entities/store-information-block';
import {buildRoute} from '../../../http';

export function getStoreInformationBlockService(
  blockId: string
): Promise<StoreInformationBlock> {
  const route = buildRoute(endpoints.GET_STORE_INFORMATION_BLOCK, [blockId]);
  return getStoreInformationBlockApi(undefined, {route}).toPromise();
}

export function listStoreInformationBlocksService(): Promise<
  StoreInformationBlock[]
> {
  return listStoreInformationBlocksApi().toPromise();
}

export type StoreInformationBlockContentRequest = {
  description: string,
  imageId: string,
  title: string,
};

export type CreateStoreInformationBlockRequest = {
  storeInformationBlockType: 'COLLAPSIBLE' | 'TEXT_IMAGE' | 'TEXT_LIST',
  title: string,
  description?: string,
  subtitle?: string,
  enabled: boolean,
  content: StoreInformationBlockContentRequest[],
};

export function createStoreInformationBlockService(
  storeInformationBlock: CreateStoreInformationBlockRequest
): Promise<StoreInformationBlock> {
  return createStoreInformationBlockApi(storeInformationBlock).toPromise();
}

export type UpdateStoreInformationBlockRequest = {
  storeInformationBlockType?: 'COLLAPSIBLE' | 'TEXT_IMAGE' | 'TEXT_LIST',
  title?: string,
  description?: string,
  subtitle?: string,
  enabled?: boolean,
  content?: StoreInformationBlockContentRequest[],
};

export function updateStoreInformationBlockService(
  blockId: string,
  storeInformationBlock: UpdateStoreInformationBlockRequest
): Promise<StoreInformationBlock> {
  const route = buildRoute(endpoints.UPDATE_STORE_INFORMATION_BLOCK, [blockId]);
  return updateStoreInformationBlockApi(storeInformationBlock, {
    route,
  }).toPromise();
}

export function deleteStoreInformationBlockService(
  blockId: string
): Promise<void> {
  const route = buildRoute(endpoints.DELETE_STORE_INFORMATION_BLOCK, [blockId]);
  return deleteStoreInformationBlockApi({route}).toPromise();
}
